import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectConnectedCrmOrgs } from '../components/pages/environments/environmentsReducer';
import useUserInfo from './useUserInfo';

export const useFetchPermissionsOnCrmOrgsChange = () => {
  const crmOrgs = useSelector(selectConnectedCrmOrgs);
  const { getPermissionsByCrmOrgIds } = useUserInfo();
  const prevCrmOrgIdsRef = useRef<string[]>([]);

  useEffect(() => {
    const crmOrgIds = crmOrgs.map((org) => org.id);
    const prevIds = prevCrmOrgIdsRef.current;

    // Check if the list of IDs has changed
    const hasChanged =
      crmOrgIds.length !== prevIds.length || crmOrgIds.some((id, i) => id !== prevIds[i]);

    if (hasChanged && crmOrgIds.length > 0) {
      getPermissionsByCrmOrgIds();
      prevCrmOrgIdsRef.current = crmOrgIds;
    }
  }, [crmOrgs, getPermissionsByCrmOrgIds]);
};
